import React, { useState } from "react";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Table,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Checkbox,
  Dropdown,
  DatePicker,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import Cookies from "js-cookie";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import config from "../config";
import withRouter from "../withRouter";

import {
  CaretDownOutlined,
  CaretUpOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  ExportOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import monthlyDistanceReportStore from "../store/MonthlyDistanceReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
const { Option } = Select;
const { RangePicker } = DatePicker;
class MonthlyDistanceList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.monthlyDistanceReportStore = new monthlyDistanceReportStore();
    this.vehicleStore = new VehicleStore();

    this.state = {
      loading: false,
      loadingData: false,
      pageSize: 50,
      pageNo: 1,
      offset: 0,
      limit: 50,
      selectedVehicles: [],
      selectAllVehicles: false,
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      fromDate: dayjs().format("YYYY-MM-DD"),
      toDate: dayjs().format("YYYY-MM-DD"),
      Notcompany: false,
      Notasset: false,
      showMonthPopup: false,
      showTable: true,
      showtotaltable: false,
      selectedColumns: [
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
          dataIndex: "vehicleNo",
          width: "15%",
          key: "vehicleNo",
        },
        {
          // title: "Month",
          title: context.translate("_MONTH_"),
          dataIndex: "month",
          width: "15%",
          key: "month",
        },
        {
          // title: "Monthly Limit",
          title: context.translate("_MONTHLY_DISTANCE_LIMIT_"),
          dataIndex: "monthlyDistanceLimit",
          width: "15%",
          key: "monthlyDistanceLimit",
        }, {
          // title: "Distance Travel",
          title: context.translate("_DISTANCE_TRAVEL_"),
          dataIndex: "distanceTravel",
          width: "15%",
          key: "distanceTravel",
        },
        {
          // title: "",
          title: context.translate("_EXCEEDED_DISTANCE_"),
          dataIndex: "exceededDistance",
          width: "15%",
          key: "exceededDistance",
        },

      ],
    };
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
        },
        {
          // label: "PDF",
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            colList: result.toString(),
          };

          if (val.key == "excel") {
            this.monthlyDistanceReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.monthlyDistanceReportStore.exportpdf(getData);
          }

        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    // await this.monthlyDistanceReportStore.loadData({ offset: 0, limit: 50 });
    await this.setState({ column: this.state.selectedColumns });

    this.columns1 = [
      {
        // title: "Vehicle No",
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: "15%",
      },
      {
        // title: "Distance Travel",
        title: this.context.translate("_DISTANCE_TRAVEL_"),
        dataIndex: "totalDist",
        width: "15%",
      },
    ];
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ loadData: 1 });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.handleSearch();
  }

  async handleSearch() {
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }


  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      this.setState({ Notcompany: false, Notasset: false });
      // if (this.checkFromDate(this.state.fromdateStdTime)) {
      await this.monthlyDistanceReportStore.loadData({
        offset: (this.state.pageNo - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        pageNo: this.state.pageNo,
      });
      // }
    }
    this.setState({ loadData: 1 });
  };

  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  showTotal = async () => {
    await this.monthlyDistanceReportStore.loadDataTotal({
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
  };
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD";
      this.setState({
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }

  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              {/* <div className="heading">Day Wise Distance Report</div> */}
              <div className="heading">
                {this.context.translate("_VEHICLE_MONTHLY_DISTANCE_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                {/* <Button
                  onClick={async () => {
                    await this.showTotal();
                    await this.setState({
                      showTable: false,
                      showtotaltable: true,
                    });
                  }}
                >
                  {this.context.translate("_TOTAL_")}
                </Button> */}

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {/* Columns */}
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.monthlyDistanceReportStore?.distanceReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {/* Export */}
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {/* <Row style={{ padding: "10px 0px" }}> */}
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 200 }}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}



                <Select
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>

                {/* <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY"
                  style={{ width: 300 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                /> */}

                <RangePicker
                  // placeholder={["From Month", "To Month"]}
                  format="MM-YYYY"
                  picker="month"
                  style={{ width: 300 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  // showTime={{
                  //   format: "h:mmA",
                  //   defaultValue: [dayjs().startOf("day"), dayjs()],
                  // }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />


                <Button
                  type="primary"
                  onClick={async () => {
                    await this.showData();
                    await this.setState({
                      showTable: true,
                      showtotaltable: false,
                    });
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>
          {/* <div
            className="accordion-list"
            onClick={() =>
              this.setState({
                showTable: !this.state.showTable,
                showtotaltable: !this.state.showtotaltable,
              })
            }
          >
            {this.context.translate("_FLEET_REPORTS_MONTHLY_DISTANCEREPORT_TITLE_")}
            <Button>
              {this.state.showTable ? (
                <CaretDownOutlined />
              ) : (
                <CaretUpOutlined />
              )}
            </Button>
          </div> */}
          {this.state.showTable && (
            <ListTable
              currentPage={this.state.currentPage}
              pageSize={this.state.pageSize}
              total={this.monthlyDistanceReportStore?.total}
              columns={this.state.column}
              dataSource={this.monthlyDistanceReportStore?.distanceReport}
              loading={this.monthlyDistanceReportStore?.loading}
              onChange={this.handleTableChange}
            // pagination={{
            //   pageSize: this.state.pageSize,
            //   total: this.monthlyDistanceReportStore.total || 0,
            // }}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
            />
          )}

          {/* <div style={{ backgroundColor: "Transparent ", color: "#0090e7", fontSize: "16px", padding: "8px 8px", fontWeight: "600", marginTop: "8px", marginBottom: "5px" }}>Total Distance</div> */}
          {/* <div
            style={{
              backgroundColor: "Transparent ",
              color: "#0090e7",
              fontSize: "16px",
              padding: "8px 8px",
              fontWeight: "600",
              marginTop: "8px",
              marginBottom: "5px",
            }}
          >
            {this.context.translate(
              "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"
            )}
          </div> */}
          {/* <div
            className="accordion-list"
            onClick={() =>
              this.setState({
                showtotaltable: !this.state.showtotaltable,
                showTable: !this.state.showTable,
              })
            }
          >
            {" "}
            {this.context.translate(
              "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"
            )}
            <Button>
              {this.state.showtotaltable ? (
                <CaretDownOutlined />
              ) : (
                <CaretUpOutlined />
              )}
            </Button>{" "}
          </div>
          {this.state.showtotaltable && (
            <ListTable
              pagination={false}
              columns={this.columns1}
              dataSource={this.monthlyDistanceReportStore?.totalReport}
              loading={this.monthlyDistanceReportStore?.loadingData}
            />
          )} */}
          {/* <ListTable
          current={this.state.currentPage}
          total={this.monthlyDistanceReportStore?.total}
          columns={this.columns}
          dataSource={this.monthlyDistanceReportStore?.distanceReport}
          loading={this.monthlyDistanceReportStore?.loading}
          onChange={this.handleTableChange}
        /> */}
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {/* For reports prior to 6 months please contact administrator */}
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
MonthlyDistanceList.contextType = StoreContext;
export default observer(withRouter(MonthlyDistanceList));
